module.exports = {"230126100":"巴彦镇","230126101":"兴隆镇","230126102":"西集镇","230126103":"洼兴镇","230126104":"龙泉镇","230126105":"巴彦港镇","230126106":"龙庙镇","230126107":"万发镇","230126108":"天增镇","230126110":"黑山镇","230126200":"松花江乡","230126202":"富江乡","230126204":"华山乡","230126205":"丰乐乡","230126209":"德祥乡","230126210":"红光乡","230126212":"山后乡","230126214":"镇东乡","230126400":"兴隆林业局","230126401":"工业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230126.json
// module id = 627
// module chunks = 0